import React, { PropsWithChildren } from 'react';
import { Outlet } from 'react-router';
import styles from './registration-layuot.module.scss';
export const RegistrationLayout: React.FC<PropsWithChildren> = ({ children }) => {
    return <div className={styles.wrapper}>{<Outlet />}</div>;
};
